<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SUNDRY SUPPLIER DOCUMENTS">
          <template slot="actions">
            <vs-button v-can="'create-edit-sundry-suppliers'" @click="onClickCreateSundrySupplierDocument" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table
              :max-documents="(meta.per_page) ? meta.per_page : 10"
              :data="documents"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%" sort-key="name">NAME</vs-th>
                <vs-th width="30%" sort-key="comment">COMMENT</vs-th>
                <vs-th width="20%">FILE</vs-th>
                <vs-th width="30%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>

                  <vs-td :data="data[indextr].comment">
                    {{ data[indextr].comment}}
                  </vs-td>

                  <vs-td :data="data[indextr].file">
                                          <vx-tooltip  class="ml-0" text="VIEW FILE" position="left">
                                            <vs-button target :href="data[indextr].file"
                                                       size="small" color="success" type="flat" icon-pack="feather" icon="icon-eye">
                                              {{__nameSplitter(data[indextr].file)}}
                                            </vs-button>
                                          </vx-tooltip>
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip v-can="'create-edit-sundry-suppliers'" class="ml-0" text="View/Update" position="left">
                        <vs-button @click="onClickUpdateSundrySupplierDocument(data[indextr])"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'delete-sundry-supplier-documents'" class="ml-2" text="Delete" position="left">
                        <vs-button @click="openStatusChangeConfirm(data[indextr].id)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxdocuments="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-documents="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-documents="descriptiondocuments"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <create-sundry-supplier-document-pop-up ref="createSundrySupplierDocumentPopUp"/>
    <update-sundry-supplier-document-pop-up ref="updateSundrySupplierDocumentPopUp" />

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SundrySuppliersRepository = RepositoryFactory.get('sundry')
  import CreateSundrySupplierDocumentPopUp from '@/components/popups/sundry-suppliers/CreateSundrySupplierDocumentPopUp'
  import UpdateSundrySupplierDocumentPopUp from '@/components/popups/sundry-suppliers/UpdateSundrySupplierDocumentPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "../../../../../constants/config";


  export default {
    name: 'AllUsersList',
    data () {
      return {
        documents: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        id: '',
        perPage: defaultPagination,
        descriptiondocuments: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      CreateSundrySupplierDocumentPopUp,
      UpdateSundrySupplierDocumentPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.id = this.$route.params.id
    },
    methods: {
      async refreshData () {
        this.fetchSundrySupplierDocuments()
      },
      async onClickSupplierView (id) {
        this.$router.push({path: `/pages/manage-nimble/suppliers/sundry/${id}`})
      },
      async fetchSundrySupplierDocuments() {
        this.$vs.loading()
        const {data} = await SundrySuppliersRepository.getListOfSundrySupplierDocuments(this.id, this.page, this.filterQuery, this.perPage, this.sort)
        this.documents =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      async onClickUpdateSundrySupplierDocument (data) {
        await this.$refs.updateSundrySupplierDocumentPopUp.openPopup(data)
      },
      async onClickCreateSundrySupplierDocument () {
        await this.$refs.createSundrySupplierDocumentPopUp.openPopup(this.id)
      },


      openStatusChangeConfirm (id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onClickDeleterSundrySupplierDocument,
          parameters: [id]
        })
      },
      async onClickDeleterSundrySupplierDocument(params) {
        this.$vs.loading()
        try {
          await SundrySuppliersRepository.sundrydocumentDelete(params[0])
          this.showSuccessMessage('Sundry supplier document deleted')
          await this.fetchSundrySupplierDocuments()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      filterQueryUpdate (){
        this.fetchSundrySupplierDocuments()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSundrySupplierDocuments()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSundrySupplierDocuments()
        }

      },
      changePage(index) {
        this.perPage = this.descriptiondocuments[index]
      },
      sundrydocumentstatusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
          case 4:
            return 'warning';
        }
      },
    },
    watch : {
      page(){
        this.fetchSundrySupplierDocuments()
      },
      perPage() {
        this.fetchSundrySupplierDocuments()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
